if (!customElements.get('bc-product-accordions')) {
  customElements.define('bc-product-accordions', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const description = this.querySelector('[data-bc-description]');
      const panels = this.querySelector('[data-bc-panels]');
      if (!description || !panels) return;
      this.dataset.initialized = 'true';
      const nodes = Array.from(description.childNodes);
      const meaningfulNodes = nodes.filter(node => node.nodeName !== 'META');
      const firstHeadingAbove = meaningfulNodes[0]?.nodeName === 'H4';
      let panel = null;
      let headingCount = 0;
      const individualPanels = document.createDocumentFragment();
      for (const node of nodes) {
        if (node.nodeName === 'H4') {
          headingCount += 1;
          if (firstHeadingAbove && headingCount === 1) continue;
          const item = document.createElement('details');
          item.className = 'bc-product-accordions__item';
          item.dataset.bcIndividual = '';
          const summary = document.createElement('summary');
          summary.append(node);
          panel = document.createElement('div');
          panel.className = 'bc-product-accordions__content rte';
          item.append(summary, panel);
          individualPanels.append(item);
        } else if (panel) {
          panel.append(node);
        }
      }
      panels.prepend(individualPanels);
      this.items = Array.from(panels.children).filter(item => item.tagName === 'DETAILS');
      this.summaries = this.items.map(item => item.querySelector('summary'));
      const instance = this.dataset.instance;
      this.items.forEach((item, index) => {
        const summary = this.summaries[index];
        const content = item.querySelector('.bc-product-accordions__content');
        item.name = `bc-accordions-${instance}`;
        item.open = false;
        summary.id = `bc-accordion-${instance}-${index}-trigger`;
        content.id = `bc-accordion-${instance}-${index}-content`;
        summary.setAttribute('aria-controls', content.id);
        summary.setAttribute('aria-expanded', 'false');
        content.setAttribute('role', 'region');
        content.setAttribute('aria-labelledby', summary.id);
        if (!summary.textContent.trim()) summary.setAttribute('aria-label', this.dataset.emptyHeadingLabel);
        summary.addEventListener('click', () => {
          if (!item.open) this.items.forEach(other => { if (other !== item) other.open = false; });
        });
        item.addEventListener('toggle', () => {
          if (item.open) this.items.forEach(other => { if (other !== item) other.open = false; });
          this.items.forEach(other => other.querySelector('summary').setAttribute('aria-expanded', String(other.open)));
        });
        summary.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowDown') target = (index + 1) % this.summaries.length;
          if (event.key === 'ArrowUp') target = (index - 1 + this.summaries.length) % this.summaries.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.summaries.length - 1;
          if (target !== undefined) {
            event.preventDefault();
            this.summaries[target].focus();
          }
        });
      });
    }
  });
}
